// extracted by mini-css-extract-plugin
module.exports = {"modal":"ReportFormModal_modal__2Fy73","show":"ReportFormModal_show__1jKOb"};